import { request } from "./request";

const BASE_URL = "/api/talents";

export default {
  async fetch(props) {
    const {
      page,
      areaOfWork,
      company,
      language,
      regions,
      workRole,
      skills,
      state,
      yearsOfExperience,
      favorite = false,
    } = props;
    return await request(BASE_URL, {
      page: page || 1,
      area_of_work: areaOfWork || undefined,
      company: company || undefined,
      language: language || undefined,
      regions: regions || undefined,
      work_role: workRole || undefined,
      skills: skills || undefined,
      state: state || undefined,
      years_of_experience: yearsOfExperience || undefined,
      favorite: favorite ? "true" : undefined,
      dynamic: window.location.href.includes("dyn=true"),
      skills_and: !window.location.href.includes("skills=or"),
    });
  },

  async fetchFilters({ areaOfWork }) {
    return await request(`${BASE_URL}/filters`, {
      area_of_work: areaOfWork || undefined,
    });
  },

  async one(talentId) {
    return await request(`${BASE_URL}/${encodeURIComponent(talentId)}`);
  },

  async share(talentId, name, password) {
    return await request({
      url: `${BASE_URL}/share`,
      method: "POST",
      data: {
        talent_id: talentId,
        name,
        password,
      },
    });
  },

  async fetchSharedProfile(linkId, token, password) {
    return await request({
      url: `${BASE_URL}/shared/${encodeURIComponent(
        linkId
      )}?token=${encodeURIComponent(token)}&password=${encodeURIComponent(
        password
      )}`,
      method: "GET",
    });
  },

  async listShareLinks(talentId) {
    return await request({
      url: `${BASE_URL}/share/${encodeURIComponent(talentId)}`,
      method: "GET",
    });
  },

  async changeState(talentId, state) {
    return await request({
      url: `${BASE_URL}/${encodeURIComponent(talentId)}/talent_state`,
      method: "PUT",
      data: {
        state,
      },
    });
  },

  async markAsFavorite(talentId) {
    return await request({
      url: `${BASE_URL}/${encodeURIComponent(talentId)}/favorite`,
      method: "PUT",
    });
  },

  async removeFromFavorites(talentId) {
    return await request({
      url: `${BASE_URL}/${encodeURIComponent(talentId)}/favorite`,
      method: "DELETE",
    });
  },
};
